export default "__VITE_ASSET__f90cd410__$_?nuxt_component=async__"